// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"72db47c6","769":"3fe7002f"}[chunkId] + ".chunk.css";
};